import { ClientLoaderFunctionArgs, useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaTagDescriptor } from "@components/MetaTags/MetaTags";
import { Route } from "@route-types/Author/+types/AuthorPage";
import { fetchAuthorPageData } from "@routes/Author/AuthorPage.server";
import AuthorPageContent from "@routes/Author/AuthorPageContent";
import { AuthorPageContext } from "@routes/Author/utils/types";
import { fetchContext, ResponseType } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

/** This is the main entry point component for /authors/:author route. */
const AuthorPage = (): React.ReactElement => {
  const context = useLoaderData<AuthorPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <AuthorPageContent
      {...context.payload.data}
      gaProps={context.payload.gaProps}
    />
  );
};

export default AuthorPage;

export const loader = async ({ request }: Route.LoaderArgs) => {
  const url = new URL(request.url, `http://localhost`);
  const path = url.pathname;

  return await fetchAuthorPageData(path);
};

export const meta = ({ loaderData }: Route.MetaArgs): MetaTagDescriptor[] => {
  const context = loaderData as AuthorPageContext;
  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return data.metaTags;
};

export const clientLoader = async (args: ClientLoaderFunctionArgs) => {
  const result = (await fetchContext(args)) as { context?: AuthorPageContext };

  if (!result.context) return await args.serverLoader();

  return result.context;
};
